import differenceInSeconds from 'date-fns/differenceInSeconds';
import {useCallback, useEffect, useState} from 'react';
import {getDateDifference} from '../../../../common/shared/utils/getDateDifference';
import useTypedDispatch from '../../../../common/useTypedDispatch';
import useTypedSelector from '../../../../common/useTypedSelector';
import {ONLY_DATA_CONFIG} from '../../../../reactQuery/constant';
import {useContentHomeOverviewQuery} from '../../../../wrapper/contentWrapper';
import {setProductListNewDot} from '../state/contentHomeSlice';

export function useContentHomeLastProductList(seriesId: number) {
  const lastSlideAddedDateStr = useContentHomeOverviewQuery(
    {seriesId},
    ONLY_DATA_CONFIG
  ).data?.contentHomeOverview?.content?.lastSlideAddedDate;
  const newDot = useTypedSelector(
    state => state.contentHome.productListNewDot[seriesId]
  );
  const dispatch = useTypedDispatch();
  const [isUpdated, setIsUpdated] = useState(false);

  useEffect(() => {
    if (newDot !== undefined) {
      setIsUpdated(newDot);
    }
  }, [newDot]);

  useEffect(() => {
    if (!lastSlideAddedDateStr) {
      return;
    }

    const lastDate = new Date(lastSlideAddedDateStr);
    const differenceWithNow = getDateDifference({
      dateLeft: new Date(),
      dateRight: lastDate,
    });
    if (differenceWithNow.days >= 1) {
      return;
    }

    const contentHomeMapStr = window.localStorage.getItem(
      LOCAL_STORAGE_KEY_CONTENT_HOME_PRODUCT_LIST_LAST_VISIT
    );

    const contentHomeMap: ContentHomeProductListLastVisitMap = contentHomeMapStr
      ? JSON.parse(contentHomeMapStr)
      : {};
    const lastVisitDate = contentHomeMap[seriesId]
      ? new Date(contentHomeMap[seriesId])
      : undefined;
    if (lastVisitDate) {
      const difference = differenceInSeconds(lastVisitDate, lastDate);
      if (difference >= 0) {
        return;
      }
    }
    setIsUpdated(true);
  }, [lastSlideAddedDateStr, seriesId]);

  const visit = useCallback(() => {
    const contentHomeMapStr = window.localStorage.getItem(
      LOCAL_STORAGE_KEY_CONTENT_HOME_PRODUCT_LIST_LAST_VISIT
    );
    const contentHomeMap: ContentHomeProductListLastVisitMap = contentHomeMapStr
      ? JSON.parse(contentHomeMapStr)
      : {};
    contentHomeMap[seriesId] = new Date().getTime();
    window.localStorage.setItem(
      LOCAL_STORAGE_KEY_CONTENT_HOME_PRODUCT_LIST_LAST_VISIT,
      JSON.stringify(contentHomeMap)
    );
    dispatch(setProductListNewDot({seriesId, newDot: false}));
  }, [dispatch, seriesId]);

  return {
    isUpdated,
    visit,
  };
}

export interface ContentHomeProductListLastVisitMap {
  [key: /* seriesId */ number]: number;
}

export const LOCAL_STORAGE_KEY_CONTENT_HOME_PRODUCT_LIST_LAST_VISIT = 'CHPLLV';
